<!--
    Notification Header

    <NotificationHeader :unread-notif-count="..." @close:menu="..."></NotificationHeader>
-->
<script setup lang="ts">
/* CONFIG */
/* COMPONENTS */
import { AfIconWithHover } from '@af-lib/ui-lib';

import Text from '@/components/text/Text.vue';
import { t } from '@/config/i18n';

/* PROPS */
type Props = {
  unreadCount?: number;
};
const props = defineProps<Props>();

/* EMITS */
const emits = defineEmits<{
  (e: 'close:menu'): void;
}>();
</script>

<template>
  <!-- Sticky header -->
  <v-sheet color="white">
    <!-- Title Menu -->
    <div class="header-title d-flex align-center justify-space-between pa-5">
      <Text type="subtitle1" role="heading" :aria-level="3">{{ t('notifications.title') }}</Text>
      <!-- Close button icon -->
      <button :aria-label="$t('general.close')">
        <AfIconWithHover size="x-small" icon="fa-xmark-large" @click="emits('close:menu')" />
      </button>
    </div>
    <v-divider></v-divider>
    <!-- Banner to display unread count of notifications -->
    <div v-if="props.unreadCount !== undefined" class="header-count">
      <Text type="body3" class="pa-4 bg-sectionSecondaryBg">
        {{ t('notifications.unread_count', { notification: props.unreadCount }) }}
      </Text>
    </div>
  </v-sheet>
</template>

<style scoped lang="scss">
.header-title {
  height: 52px;
}

.header-count {
  height: 53px;
}
</style>
